import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Heading, Loading } from 'components';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { useRouterStore } from 'apps/hooks';
import { useAppManager } from 'core/hooks';
import DocumentHead from 'legacyComponents/documentHead';
import { ShipmentProductQuotesTable } from '../../productQuote/ProductQuoteTables';
import { ShippingDetails } from '../ShippingDetails';
import { Miscellaneous } from '../Miscellaneous';
import { ShipmentQuoteDetails } from '../QuoteDetails';
import { ShipmentSummary } from '../ShipmentSummary';
import CreateShipmentQuoteAppManager from '../appManager';
import { ProductQuotesSideBar } from '../../productQuote';

export const CreateShipmentQuotePage = observer(() => {
  const { route } = useRouterStore();
  const shipmentQuoteAppManager = useAppManager(
    CreateShipmentQuoteAppManager,
    null,
  );
  const { shipmentQuoteFormStore, productQuote } = shipmentQuoteAppManager;

  const handeModalClose = () => {
    shipmentQuoteAppManager.productQuote = null;
  };

  useEffect(() => {
    if (route.params.mode === 'clone' && route.params.cloneId) {
      shipmentQuoteAppManager.CloneQuote(route.params.cloneId);
    }
  }, [route.params.mode, route.params.cloneId]);

  if (route.params.mode === 'clone' && shipmentQuoteAppManager.cloning) {
    return <Loading />;
  }

  return (
    <MainWrapper marginTop='2rem'>
      <DocumentHead title='New Quote' />
      <Heading level={2} size='large'>
        New Quote for{' '}
        <span style={{ fontWeight: 'normal' }}>
          {route.params.customerSlug}
        </span>
      </Heading>
      <ShipmentQuoteDetails shipmentQuoteFormStore={shipmentQuoteFormStore} />
      <ShipmentProductQuotesTable
        shipmentQuoteAppManager={shipmentQuoteAppManager}
      />

      <ShippingDetails shipmentQuoteAppManager={shipmentQuoteAppManager} />
      <Miscellaneous
        quote={shipmentQuoteAppManager.shipmentQuoteApp}
        newMiscFormStore={shipmentQuoteAppManager.miscItemFormStore}
      />
      <ShipmentSummary shipmentQuoteAppManager={shipmentQuoteAppManager} />
      {productQuote ? (
        <ProductQuotesSideBar
          productQuoteApp={productQuote}
          onModalClose={handeModalClose}
          shipmentQuoteAppManager={shipmentQuoteAppManager}
        />
      ) : null}
    </MainWrapper>
  );
});
